/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Merge_LabelInputs */



/**
* | output |
* | --- |
* | "Merge Events" |
*
* @param {Context_Menu_Merge_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_merge_label = /** @type {((inputs?: Context_Menu_Merge_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Merge_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner les evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführungsereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слияние событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをマージする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विलय घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesclar eventos")
	return /** @type {LocalizedString} */ ("Merge Events")
});